import { useState } from "react";
import { exportMPDashboardCsv } from "../api/exportMPDashboardCsv/exportMPDashboardCsvApi";
import { ExportMPDashboardCsvRequest } from "../api/exportMPDashboardCsv/types";
import { downloadFile } from "@/utils/downloadFile";

export function useDownloadMPDashboardCsv() {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const downloadCsv = async (requestData: ExportMPDashboardCsvRequest) => {
    setLoading(true);
    setError(null);
    try {
      const blob = await exportMPDashboardCsv(requestData);
      const timestamp = new Date().toISOString().split("T")[0];
      const fileName = `market-presence-${timestamp}.csv`;
      downloadFile(blob, fileName);
    } catch (err: unknown) {
      if (err instanceof Error) {
        console.error("MP Dashboard CSV download error:", err.message);
        setError(err.message);
      } else {
        setError("Failed to download Market Presence CSV");
      }
    } finally {
      setLoading(false);
    }
  };

  return {
    loading,
    downloadCsv,
    error,
  };
}
